import React, { useEffect, useState, useRef } from "react";
import { Nav, Col, NavItem, Navbar, Row, Container } from "react-bootstrap";
import { useLocation, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchSignIn } from "../store/thunks/fetch-sign-in-thunk";
import { fetchJobs } from "../store/thunks/fetch-jobs-thunk";
import { selectSignIn } from "../store/slices/signed-in-slice";
import { fetchIndividualAssessments } from "../store/thunks/fetch-individual-assessments-thunk";
import { selectIndividualAssessmentsStatus } from "../store/slices/individual-assessment-listings-slice";
import { selectIndividualAssessmentsList } from "../store/slices/individual-assessment-listings-slice";
import { NavLink, Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { selectJobsStatus } from "../store/slices/job-listings-slice";
import { resetJobData } from "../store/slices/job-data-slice";
import { resetApplications } from "../store/slices/application-slice";
import { resetSignIn } from "../store/slices/signed-in-slice";
import { deleteTokens } from "./Sign-Out/Delete-Tokens";
import DpmLogo from "../components/Images/glowDPM.png";
import "./Root.css";
import { fetchProfile } from "../store/thunks/fetch-profile-thunk";
import UserIcon from "../components/Images/userIcon.png";
import {FaFacebook, FaSignOutAlt} from "react-icons/fa";
import { FaPhoneVolume } from "react-icons/fa6";
import { CgWebsite } from "react-icons/cg";
import { SiMinutemailer } from "react-icons/si";
import { Maintenance } from "./Maintenance/maintenance";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import {
    IoIosHome,
    IoIosPaper,
    IoIosSearch,
    IoMdHelpCircleOutline,
    IoMdHome,
    IoMdLogOut,
    IoMdSettings
} from "react-icons/io";
import {AiOutlineLogout} from "react-icons/ai";
import {selectProfile} from "../store/slices/profile-slice";

const getClassName = ({ isActive, isPending, isTransitioning }) =>
    [
        "text-black",
        isPending ? "" : "link-active",
        isActive ? "active" : "not-active",
        isTransitioning ? "" : "",
    ].join(" ");

const menuItems = [
    { to: "",  label:
            <div>
                <IoIosHome/> Home
            </div>,  alwaysVisible: true },
    // { to: "profileCard", label: "Profile" },
    { to: "application",   label:
            <div>
                <IoIosPaper /> My Applications
            </div>,},
    { to: "jobs", label:
            <div>
                <IoIosSearch /> Jobs
            </div>,  alwaysVisible: true },
    { to: "signin", label: "Sign-in", onlyWhenSignedOut: true },
    { to: "signup", label: "Sign-up", onlyWhenSignedOut: true },
    { to: "security-settings",   label:
            <div>
                <IoMdSettings /> Security
            </div> },
    { to: "faq",  label:
            <div>
                <IoMdHelpCircleOutline /> FAQ
            </div>, alwaysVisible: true },
];

export const Root = () => {
    const location = useLocation(); // get current location
    const [open, setOpen] = useState(false);
    const [showSignOut, setShowSignOut] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    // Select the state of the user's sign in status
    const isSignedIn = useSelector(selectSignIn);
    const profile = useSelector(selectProfile); //returns that state of profile
    // Select the state of the job list loaded status
    const isJobsLoaded = useSelector(selectJobsStatus);

    // Select the state of the individual assessments list loaded status
    const isIndividualAssessmentsLoaded = useSelector(
        selectIndividualAssessmentsStatus,
    );

    const hasIndividualAssessments = useSelector(
        selectIndividualAssessmentsList,
    );

    // Extracts pathname property(key) from an object
    const { pathname } = useLocation();

    
    // Automatically get IAs whenever pathname changes
    useEffect(() => {
        if (isSignedIn && isIndividualAssessmentsLoaded !== "succeeded") {
            dispatch(fetchIndividualAssessments());
        }
    }, [pathname]);


    // If the job list has not been loaded
    // dispatch action to load the data
    useEffect(() => {
        if (isJobsLoaded === "idle") {
            dispatch(fetchJobs());
        }
    }, [isJobsLoaded, dispatch]);

    // On load, get the user's sign in status
    useEffect(() => {
        dispatch(fetchSignIn());
        if (isSignedIn) {
            // dispatch(fetchIndividualAssessments());
            dispatch(fetchProfile());
        }
    }, [dispatch, isSignedIn]);

    

    const signOut = async () => {
        // deletes the tokens and makes a request to the controller
        await deleteTokens();
        // Reset the slices
        dispatch(resetJobData());
        dispatch(resetApplications());
        dispatch(resetSignIn());
        navigate("/signin");
        // remove the selected job
        localStorage.removeItem("storedJob")
    };

    const handleClick = () => {
        navigate("/");
    };

    const copyEmail = async () => {
        await navigator.clipboard.writeText("apply@dpm.navajo-nsn.gov");
    };

    // eslint-disable-next-line no-undef
    const isUnderMaintenance = process.env.REACT_APP_MAINTENANCE ?? "false";
    if (isUnderMaintenance === "true") {
        return (
            <Maintenance />
        )
    }

    const showBanner = false;
    let announcement = "Scheduled Maintenance: 9/21/2026 The Apply portal will be unavailable from 12:00pm to 1:00pm (MDT) due to scheduled maintenance.";

    return (
        <>
            <ToastContainer containerId={"root"} />
            <Row
                onClick={() => handleClick()}
                className="shadow-sm nav-bg-color m-0 p-0 nav-font"
                style={{
                    minWidth: "100vw",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <Col xs={3} lg={5} className="d-flex justify-content-end">
                    <img src={DpmLogo} width="90" height="auto" alt="Logo" />
                </Col>
                <Col xs={9} lg={7} className="d-flex justify-content-start">
                    <span className=" text-white navbar-title py-4">
                        Department of Personnel Management
                    </span>
                </Col>
            </Row>

            {showBanner &&
                (<header className="container-fluid bg-warning pt-2 ">
                    <Row>
                        <h5 className="text-center align-middle text-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-megaphone" viewBox="0 0 16 16">
                                <path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-.214c-2.162-1.241-4.49-1.843-6.912-2.083l.405 2.712A1 1 0 0 1 5.51 15.1h-.548a1 1 0 0 1-.916-.599l-1.85-3.49-.202-.003A2.014 2.014 0 0 1 0 9V7a2.02 2.02 0 0 1 1.992-2.013 75 75 0 0 0 2.483-.075c3.043-.154 6.148-.849 8.525-2.199zm1 0v11a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-1 0m-1 1.35c-2.344 1.205-5.209 1.842-8 2.033v4.233q.27.015.537.036c2.568.189 5.093.744 7.463 1.993zm-9 6.215v-4.13a95 95 0 0 1-1.992.052A1.02 1.02 0 0 0 1 7v2c0 .55.448 1.002 1.006 1.009A61 61 0 0 1 4 10.065m-.657.975 1.609 3.037.01.024h.548l-.002-.014-.443-2.966a68 68 0 0 0-1.722-.082z" />
                            </svg>&nbsp;&nbsp;
                            {announcement}
                        </h5>
                    </Row>
                </header>)}

            <Navbar
                className="d-flex justify-content-center shadow-sm py-2"
                collapseOnSelect
                expand="lg"
                expanded={open}
            >
                <Navbar.Toggle
                    style={{
                        width: "100%",
                    }}
                    className="hamburger-color"
                    onClick={() => setOpen(!open)}
                    aria-controls="responsive-navbar-nav"
                />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Row className="d-flex flex-row justify-content-between w-100">
                    <Nav >
                        {menuItems.map(
                            (item) =>
                                (item.alwaysVisible ||
                                    (isSignedIn && !item.onlyWhenSignedOut) ||
                                    (isIndividualAssessmentsLoaded ===
                                        "succeeded" &&
                                        hasIndividualAssessments.length > 0 &&
                                        item.to === "individual-assessments") ||
                                    (!isSignedIn &&
                                        item.onlyWhenSignedOut)) && (
                                    <Col key={item.to} className="col-auto mx-3">
                                        <Col className="d-flex justify-content-center col-auto px-lg-3 py-lg-2">
                                            <NavLink
                                                className={getClassName}
                                                to={item.to}
                                                onClick={() => setOpen(false)}
                                            >
                                                {item.label}
                                            </NavLink>
                                        </Col>
                                    </Col>
                                ),
                        )}
                        {isIndividualAssessmentsLoaded === "succeeded" &&
                            hasIndividualAssessments.length > 0 &&
                            isSignedIn && (
                                <Col
                                    key={"individual-assessments"}
                                    className="col-auto"
                                >
                                    <Col className="d-flex justify-content-center col-auto px-lg-3 py-2 mx-3">
                                        <NavLink
                                            className={getClassName}
                                            to={"individual-assessments"}
                                            onClick={() => setOpen(false)}
                                        >
                                            {"Individual Assessments"}
                                        </NavLink>
                                    </Col>
                                </Col>
                            )}
                        {isSignedIn && (
                            <Col className="col-auto" >
                                <Col className="d-flex justify-content-center col-auto px-lg-3 py-2 mx-3 ">
                                    <NavLink
                                        className={getClassName}
                                        to={"signin"}
                                        onClick={() => {
                                            signOut();
                                            setOpen(false);
                                            return true;
                                        }}
                                    >
                                        <div>
                                            <FaSignOutAlt/> Sign Out
                                        </div>
                                    </NavLink>
                                </Col>
                            </Col>
                        )}
                        {
                            isSignedIn && (
                                <div className="d-flex flex-nowrap justify-content-xl-end justify-content-center w-100">
                                    <NavLink
                                        className={getClassName}
                                        to={"signin"}
                                        onMouseEnter={() => setShowSignOut(true)}
                                        onMouseLeave={() => setShowSignOut(false)}
                                    >
                                        <div className="d-flex align-items-center">
                                            <img src={UserIcon} width="32" height="auto" alt="Logo"
                                                 style={{marginRight: '15px'}}/>
                                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                                <div className="text-primary fw-medium">{profile.firstName} {profile.lastName}</div>
                                                <div className="fw-medium" style={{fontSize: '0.9em'}}>
                                                    Current User
                                                </div>
                                            </div>
                                            {showSignOut && (
                                                <NavLink
                                                    onClick={() => {
                                                        signOut();
                                                        setOpen(false);
                                                        return true;
                                                    }}
                                                    to={"signin"}
                                                    className="notYouLink mx-4"
                                                    style={{ opacity: 0.5 }}
                                                >
                                                    <div>
                                                        <FaSignOutAlt/> Not You?
                                                    </div>
                                                </NavLink>
                                            )}
                                        </div>
                                    </NavLink>
                                </div>
                            )
                        }
                    </Nav>
                    </Row>


                </Navbar.Collapse>
            </Navbar>
            <Row
                className="m-0 p-0"
                id="detail"
                style={{
                    minHeight: "78.5vh",
                    minWidth: "100vw",
                    display: "flex",
                }}
            >
                <Col>
                    <Outlet/>
                </Col>
            </Row>
            <Row
                xs={12}
                className="m-0 p-0 shadow-sm nav-bg-color footer-font"
                style={{
                    position: "relative",
                    minHeight: "4vh",
                    display: "flex",
                    alignItems: "center",
                    minWidth: "100vw",
                }}
            >
                <Row className="d-flex fluid justify-content-center m-0 p-0">
                    <Col sm={4} className="d-flex fluid justify-content-center">
                        <div>
                            <h5 className="mt-1 p-0 d-flex fluid justify-content-center">
                                Contact Information:
                            </h5>
                            <hr className="mt-2 mb-2"></hr>
                            <a
                                className="footer-link d-flex fluid justify-content-center"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                                href="tel://9283576697"
                            >
                                <FaPhoneVolume /> &nbsp;(928) 357-6697
                            </a>
                            <a className="footer-link" onClick={copyEmail}>
                                <SiMinutemailer /> DPM.ITSupport@dpm.navajo-nsn.gov
                            </a>
                        </div>
                    </Col>
                    <Col sm={4} className="d-flex fluid justify-content-center">
                        <div>
                            <h5 className="mt-1 p-0 d-flex fluid justify-content-center">
                                Resources:
                            </h5>
                            <hr className="mt-2 mb-2"></hr>
                            <a
                                className="footer-link d-flex fluid justify-content-center"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                                target="_blank"
                                rel="noopen noreferrer"
                                href="https://www.dpm.navajo-nsn.gov"
                            >
                                <CgWebsite /> &nbsp;dpm.navajo-nsn.gov
                            </a>
                        </div>
                    </Col>
                    <Col sm={4} className="d-flex fluid justify-content-center">
                        <div>
                            <h5 className="mt-1 p-0 d-flex fluid justify-content-center">
                                Follow us here:
                            </h5>
                            <hr className="mt-2 mb-2"></hr>
                            <a
                                className="footer-link d-flex fluid justify-content-center fs-5"
                                target="_blank"
                                rel="noopen noreferrer"
                                href="https://facebook.com/nn.apply"
                            >
                                <FaFacebook />
                            </a>
                        </div>
                    </Col>
                </Row>
                <Row className="d-flex fluid justify-content-center  m-0 p-0">
                    © Copyright 2026 NAVAJO NATION DPM All Rights Reserved
                </Row>
                <Row className="d-flex justify-content-center m-0 p-0">
                    <div className="center-div">
                        <Link to="/terms-of-use" className="links">
                            Terms of Use
                        </Link>{" "}
                        |
                        <Link to="/privacy-policy" className="links">
                            Privacy Policy
                        </Link>{" "}
                        |
                        <Link to="/disclaimer" className="links">
                            Disclaimer
                        </Link>
                    </div>
                </Row>
            </Row>
        </>
    );
};
